module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticClass: "head-nav"
  }, [_c('el-col', {
    staticClass: "logo-box",
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    class: {
      topLogoImg: _vm.topLogoImg
    },
    attrs: {
      "src": _vm.logoImg
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.apiRootName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.dataroles == 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.routes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name) + "\n\t\t\t\t\t\t\t")])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("机构管理菜单")]), _vm._v(" "), _vm._l((_vm.agencyProxyRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    key: "/other",
    staticClass: "color-fff $route.path==/other'is-active':''",
    attrs: {
      "index": "/other"
    }
  }, [_vm._v("其它\n\t\t\t\t\t\t\t")])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 100) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active1",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("课程管理菜单")]), _vm._v(" "), _vm._l((_vm.courseManagementRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 6 && _vm.requestUnit != 'IsFangCao' && _vm.requestUnit != 'IsBeiMa') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 6) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.allianceRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_c('span', [_vm._v(_vm._s(route.name))])])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("信息管理")]), _vm._v(" "), _vm._l((_vm.allianceChildRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    key: "/importData",
    staticClass: "color-fff $route.path==/main/import_data?'is-active':''",
    attrs: {
      "index": "/importData"
    }
  }, [_vm._v("数据导入\n\t\t\t\t\t")]), _vm._v(" "), _c('el-menu-item', {
    key: "/allianceMain/helpCenter/introduction",
    staticClass: "color-fff $route.path==/main4/introduction?index=3'is-active':''",
    attrs: {
      "index": "/allianceMain/helpCenter/introduction"
    }
  }, [_vm._v("帮助中心\n\t\t\t\t\t")])], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 6 && (_vm.requestUnit == 'IsFangCao' || _vm.requestUnit == 'IsBeiMa')) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 6) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.fangCaoAllianceRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_c('span', [_vm._v(_vm._s(route.name))])])
  }), _vm._v(" "), _c('el-menu-item', {
    key: "/importData",
    staticClass: "color-fff $route.path==/main/import_data?'is-active':''",
    attrs: {
      "index": "/importData"
    }
  }, [_vm._v("数据导入\n\t\t\t\t\t")]), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("课程管理菜单")]), _vm._v(" "), _vm._l((_vm.courseManagementRoutes), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 4) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 4) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.agencyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 5 && _vm.requestUnit == 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 5) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.fangCaoProxyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 5 && _vm.requestUnit != 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 5) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, _vm._l((_vm.proxyRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 1 && (_vm.requestUnit == 'IsFangCao' || _vm.requestUnit == 'IsBeiMa')) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 1) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.fangCaoKgRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 1 && _vm.requestUnit != 'IsFangCao' && _vm.requestUnit != 'IsBeiMa') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 1) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.kgRoutes), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataroles == 7 && _vm.requestUnit != 'IsFangCao') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.dataroles == 7) ? _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.kgRoutesProbation), function(route) {
    return _c('el-menu-item', {
      key: route.path,
      staticClass: "color-fff",
      class: _vm.$route.path == route.path ? 'is-active' : '',
      attrs: {
        "index": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "allince-menu",
    attrs: {
      "index": "active",
      "mode": "horizontal"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("数据处理")]), _vm._v(" "), _vm._l((_vm.kindergartenDataBase), function(routes) {
    return _c('el-menu-item', {
      key: routes.path,
      class: _vm.$route.path == routes.path ? 'is-active' : '',
      attrs: {
        "index": routes.path
      }
    }, [_vm._v(_vm._s(routes.name))])
  })], 2)], 2) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    staticClass: "userinfo "
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/user-icon.png"
    }
  }), _vm._v("\n\t\t\t\t\t    " + _vm._s(_vm.admin) + " "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "userinfo-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.dataroles !== 0) ? _c('el-dropdown-item', [_c('span', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t修改密码\n\t\t\t\t\t\t\t")])]) : _c('el-dropdown-item'), _vm._v(" "), _c('el-dropdown-item', [_c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t退出登录\n\t\t\t\t\t\t\t\t")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogFormVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm,
      "label-width": "70px",
      "rules": _vm.passFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "oldPassword", $$v)
      },
      expression: "passForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "newPassword", $$v)
      },
      expression: "passForm.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5,
      "offset": 5
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "版本更新",
      "visible": _vm.dialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "70px"
    }
  }, [_c('p', {
    staticClass: "update-dialog-p",
    domProps: {
      "innerHTML": _vm._s(_vm.dalogTxt)
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5,
      "offset": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8b000a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headTop.vue
// module id = 244
// module chunks = 65